import { FC } from 'react'

import { RegStep } from '../../data'

import styles from './change-email.module.scss'

interface IChangeEmail {
  setStep: React.Dispatch<React.SetStateAction<RegStep>>
}

const ChangeEmail: FC<IChangeEmail> = ({ setStep }) => {
  const clickHandler = () => {
    setStep(RegStep.EMAIL_WIDGET)
  }
  return (
    <div className={styles.btn} onClick={clickHandler}>
      Изменить
    </div>
  )
}

export default ChangeEmail
